import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import axios from 'axios';
import { ProductPostState } from 'common-ts/dist/models/Product';
import { fetchProductsList } from "./ProductListRedux";

const initialState: ProductPostState = {
    productDraft: {
        productBackendVersion: "", // KEEP EMPTY, AUTOFILLED IN BACKEND
        measurementNeeded: [], // KEEP EMPTY, AUTOFILLED IN BACKEND

        allClothIdList: [], // KEEP EMPTY, AUTOFILLED IN BACKEND
        allRequestPatternList: [], // KEEP EMPTY, AUTOFILLED IN BACKEND
        allUnitItemIdList: [], // KEEP EMPTY, AUTOFILLED IN BACKEND
        allMidstockIdList: [], // KEEP EMPTY, AUTOFILLED IN BACKEND
        allMidstockPatternList: [], // KEEP EMPTY, AUTOFILLED IN BACKEND

        cacheSetMeasurementNeeded: [],
        cacheSetMeasurementRules: [],
        cacheSetSizeMeasurementValues: [],
        cacheSetSizeNames: [],

        midstockMeasurementNeeded: [],
        midstockMeasurementRules: [],
        midstockSizeMeasurementValues: [],
        midstockSizeNames: [],

        resourceDecisionTree: {
          nodeType: "NodeAnd",
          childrenNodes: [],
        }
    },

    productCreateDialogOpen: false,
    productCreateCopyDialogOpen: false,

    status: APIRequestStatus.Idle,
    error: ''
}

const newProductSlice = createSlice({
    name: 'productCreate',
    initialState,
    reducers: {
        updateVal(state, action) {
            state.productDraft = action.payload
            console.log(`State values: ${JSON.stringify(state.productDraft)}`)
        },
        updateDialogOpen(state, action) {
            state.productCreateDialogOpen = action.payload;
        },
        updateDialogOpenCopy(state, action) {
            state.productCreateCopyDialogOpen = action.payload;
        }
    },
    extraReducers(builder) {
        builder
          .addCase(postNewProduct.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postNewProduct.fulfilled, (state, action) => {
            state.status = APIRequestStatus.Success;
            // The Create and Copy dialogs close themselves once EVERY step succeeded
            // (midstock, product, hutang) — closing here on the first product success
            // hid later failures from their result summaries.
          })
          .addCase(postNewProduct.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("fetch is failure");
          })
      }
})

export const postNewProduct = createAsyncThunk('productCreate/postNewProduct', async (arg: any, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/product',
      data: arg
    });

    thunkAPI.dispatch(fetchProductsList());

    return response.data
})

export const { updateVal, updateDialogOpen, updateDialogOpenCopy } = newProductSlice.actions

export default newProductSlice.reducer